import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../Loader/loader/loader.component';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import * as XLSX from 'xlsx';
import { CommonService } from '../../../Model/Common/common.service';
import { AlertWarningComponent } from '../../Alert/alert-warning/alert-warning.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { ShiftGroupService } from '../../../Model/ShiftGroup/shift-group.service';
import { LocationServiceService } from '../../../Model/LocationMaster/location-service.service';
import e from 'express';
import { ComboService } from '../../../Model/Combo/combo.service';

@Component({
  selector: 'app-common-upload',
  standalone: true,
  imports: [FormsModule, CommonModule, DataTablesModule, LoaderComponent],
  templateUrl: './common-upload.component.html',
  styleUrl: './common-upload.component.scss'
})
export class CommonUploadComponent {
  isDisabled: boolean = false;
  uploadfile = null as any;
  //ExcelData: any[] = [];
  excelcheck = false;
  recodecheck = false;
  allowsubmit = false;
  Input_ExcelUploadMasterID = 5;
  ExcelHeadersIndex = null as any;

  excelHeader = [] as any;
  excelData = [] as any;
  excelDataResult = [] as any;

  IndustrySeg = [] as any;
  ServiceType: any[] = [];
  RegionMaster: any[] = [];
  BranchMaster: any[] = [];
  CustomerGroup: any[] = [];
  BillingCustomer: any[] = [];
  FinancialBranch: any[] = [];
  Group: any[] = [];
  State: any[] = [];
  District: any[] = [];
  Taluka: any[] = [];
  ZoneMaster: any[] = [];
  SiteOwner: any[] = [];
  ReportTypeMaster: any[] = [];
  DesignationLoad: any[] = [];
  DutyLoad: any[] = [];
  Shift: any[] = [];
  ManPowerTable: any[] = [];
  SiteType: any[] = [];
  Channels: any[] = [];
  Banks: any[] = [];
  AttendanceThroughLoad: any[] = [];
  LeaveSalaryCycleLoad: any[] = [];
  LeaveSalaryPayoutLoad: any[] = [];
  PayoutBonusesCycleLoad: any[] = [];
  PayoutBonusLoad: any[] = [];
  GratuityLoad: any[] = [];
  UniformLoad: any[] = [];
  MinimumWageIndustryLoad: any[] = [];
  MinimumWageZoneLoad: any[] = [];
  WageStrutureLoad: any[] = [];
  Groups: any[] = [];
  SubGroups: any[] = [];
  FilteredSubGroups: any[] = [];

  BillTypes = ['Fixed Billing', 'Muster Billing', 'BillOnSalaryCTC'];
  Compliance = ['Compliance', 'Non-Compliance'];
  MaterialChargesType = ['Fixed Value', 'Rate / Sq. Ft.', 'Percentage', 'At Actual'];
  MachineryChargesType = ['Fixed Value', 'Percentage'];
  SalaryBillingCalcOn = [{ Name: 'Total Month Days', Value: 'M' },
  { Name: 'Total Working Days', Value: 'W' },
  { Name: 'Per Day', Value: 'P' },
  { Name: 'Fix Days', Value: 'F' },
  { Name: 'Month Days', Value: 'S' },]

  ExcelHeaders = [
    // {
    //   ESS_ExcelUploadMasterID: 1,//ShiftMaster
    //   Headers: ['ShiftMasterid', 'ShiftCode', 'ShiftTitle', 'InTime', 'OutTime', 'DefaultShift', 'RotationalShift	ShiftGroupName'],
    // }, 
    {
      ESS_ExcelUploadMasterID: 2,//ShiftGroupMaster
      Headers: ['ESS_ShiftGroupMasterID', 'ShiftGroupName'],
    },
    // {
    //   ESS_ExcelUploadMasterID: 3,//RoleMaster
    //   Headers: ['WebESSRoleMasterID', 'RoleName'],
    // }, {
    //   ESS_ExcelUploadMasterID: 4,//SiteTypeMaster
    //   Headers: ['SiteTypeMasterID', 'SiteTypeName'],
    // },
    {
      ESS_ExcelUploadMasterID: 5,//Site Master
      Headers: ['Location ID', 'Location Code', 'Location Name', 'Branch Name', 'Client Group Code', 'Client Group Name', 'Max Client Name', 'IndustrySegmentGroupName', 'IndustrySegmentName',
        'Rate Contract Group', 'Zone Name', 'SiteGroupName', 'SiteSubGroupName', 'ChannelGroupName', 'ChannelName', 'ServiceTypeName', 'BankName', 'Address1', 'Address2',
        'City', 'State Name', 'District Name', 'Taluka Name', 'PinCode', 'TelephoneNo', 'Contact Person Name', 'Contact Person TelNo', 'Contact Person Email', 'BillType',
        'Compliance', 'PFApplicable', 'ESICApplicable', 'PTApplicable', 'LWFApplicable', 'OpenMonth', 'OpenYear', 'SiteStartDate', 'SiteEndDate', 'Remark', 'IsMapped',
        'SiteOwnerName', 'Latitude', 'Longitude', 'Radius', 'Accuracy', 'Altitude', 'heading', 'isMocked', 'IsAltitudeApplicable', 'AltitudeRadius', 'Multiple Gate', 'Area(SqFt)',
        'Material Charge', 'Material Charge Type', 'Machinery Charge Type', 'Machinery Charge', 'Salary Calc Type', 'Salary From', 'Salary To', 'Salary Calc On', 'Billing Calc Type',
        'Billing From', 'Billing To', 'Billing Calc On', 'Site Creation Date', 'IsInternalPOCApplicable', 'InternalPOCName', 'InternalPOCMobileNo', 'InternalPOCMailId', 'IsClientPOCApplicable',
        'ClientPOCName', 'ClientPOCMobileNo', 'ClientPOCMailId', 'SiteOracleCode', 'SiteAlternateCode', 'SiteAgreementCopyAttachment', 'SiteAttendanceThrough', 'SiteLeaveSalarCycle',
        'SiteLeaveSalary', 'SitePayoutBonusesCycle', 'SitePayoutBonus', 'SiteGratuity', 'SiteUniforms', 'SiteIsUniformsDeposit', 'SiteMinimumWageIndustry', 'SiteMinimumWageZone', 'SiteMinimumWageStructure',
        'SiteBillTo', 'SiteShipTo', 'SiteAutoMail', 'SitePlaceOfSupplyApplicable', 'SiteDefaultNarration', 'IsClientAttendanceInformationMail'],
    },
  ];

  constructor(
    protected common: CommonService,
    private toast: ToastService,
    private modalService: NgbModal,
    private download: DownloadSampleService,
    private shift: ShiftGroupService,
    private locationservice: LocationServiceService,
    private comboload: ComboService,
  ) {
    //this.common.getPageRights();
  }

  handleFileInputChange(event: any): void {
    //this.ExcelData = [];
    const files: FileList = event.target.files;

    const input = event.target as HTMLInputElement;

    if (files && files.length > 0) {
      const file: File = files[0];
      const fileType: string | undefined = file.name.split('.').pop();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
        return;
      } else {
        this.uploadfile = file;
      }
      //this.processExcelFile(file);
      event.target.value = '';
    }
  }

  ngOnInit(): void {
    this.ExcelHeadersIndex = this.ExcelHeaders.findIndex(e => e.ESS_ExcelUploadMasterID == this.Input_ExcelUploadMasterID);
  }

  processExcelFile(file: File): void {
    this.isDisabled = true;
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = 'Sheet1';
        if (!workbook.SheetNames.includes(sheetName)) {
          const errorMessage = 'Sheet1 not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        if (excelData.length > 1) {
          const headerRow = excelData[0];
          const headers = headerRow.map((header: string) => header.replace(/\s+/g, ''));
          this.allowsubmit = false;
          this.excelcheck = true;

          if (this.ExcelHeaders.length > 0) {
            this.ExcelHeaders[this.ExcelHeadersIndex].Headers.forEach(element => {
              if (this.excelcheck) {
                if (headers.findIndex(e => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(element.replace(/\s+/g, ''))) >= 0) {
                  this.excelcheck = true;
                } else {
                  //this.excelcheck = false;
                }
              }

              if (!this.excelcheck) {
                return;
              }
            });
          }

          if (!this.excelcheck) {
            this.reset();
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = "Excel file column not match. please check sample file";
            modalRef.result.then((result: any) => { });
          } else {
            this.allowsubmit = true;
            this.submit(excelData);
          }
          this.isDisabled = false;
        } else {
          this.reset();
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = "Excel file have a no data";
          modalRef.result.then((result: any) => { });
        }
      } else {
        console.error('Failed to read the file.');
        this.isDisabled = false;
      }
    };
    reader.readAsBinaryString(file);
  }

  uploadfileData() {
    const file: File = this.uploadfile;
    const fileType: string | undefined = file.name.split('.').pop();
    if (fileType !== 'xlsx' && fileType !== 'xls') {
      this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
      return;
    }
    this.processExcelFile(file);
  }

  reset() {
    this.isDisabled = false;
    this.allowsubmit = false;
    this.removeFile();
  }

  removeFile() {
    this.setallowsubmit();
    this.uploadfile = null;
  }

  setallowsubmit() {
    this.allowsubmit = false;
  }

  downloadExcel() { }

  submit(excelDatas: any) {
    if (this.allowsubmit) {
      this.excelHeader = [];
      this.excelData = [];
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to submit?';
      modalRef.result.then(async result => {
        if (result) {
          if (this.Input_ExcelUploadMasterID == 5) {
            await this.loadSiteData(null);
          }

          this.excelHeader = excelDatas[0];
          this.excelData = excelDatas.slice(1);
          this.isDisabled = true;
          this.excelDataResult = [];
          for (let rindex = 0; rindex < this.excelData.length; rindex++) {
            const element = this.excelData[rindex];
            this.excelDataResult[rindex] = {};

            if (this.Input_ExcelUploadMasterID == 2) {
              if (element[this.excelHeader.findIndex((e: any) => e.replace(/\s+/g, '') == this.ExcelHeaders[this.ExcelHeadersIndex].Headers[1].replace(/\s+/g, ''))] != null
                && element[this.excelHeader.findIndex((e: any) => e.replace(/\s+/g, '') == this.ExcelHeaders[this.ExcelHeadersIndex].Headers[1].replace(/\s+/g, ''))] != '') {
                await this.SaveFromExcelShiftGroup(element);
              } else {
                element.Result = "Site group blank not allow";
              }
            } else if (this.Input_ExcelUploadMasterID == 5) {
              this.recodecheck = true;
              const SiteIndertUpdate = {
                SelectType: null as any,
                SiteMasterId: null as any,
                IndustrySegmentID: null as any,
                ServiceTypeID: null as any,
                RegionID: null as any,
                BranchID: null as any,
                ClientGroupId: null as any,
                MaxClientId: null as any,
                SiteCode: null as any,
                SiteName: null as any,
                FinancialBranchID: null as any,
                GroupID: null as any,
                Address1: null as any,
                Address2: null as any,
                City: null as any,
                PinCode: null as any,
                TelephoneNo: null as any,
                StateID: null as any,
                DistrictID: null as any,
                TalukaID: null as any,
                ContactPersonName: null,
                ContactPersonEmail: null,
                ContactPersonNo: null,
                Compliance: null as any,
                BillType: null as any,
                BillDutyDivisionBy: null,
                ZoneId: null,
                PFApplicable: null as any,
                ESICApplicable: null as any,
                PTApplicable: null as any,
                LWFApplicable: null as any,
                WeeklyOffDivideBy: null,
                PFonBasicDAOT: null,
                AdminChargesApplicable: null,
                OnlineAttendanceFreeze: null,
                Active: null,
                SalaryCalcType: null as any,
                SalaryFrom: null as any,
                SalaryTo: null as any,
                BillingCalcType: null as any,
                BillingFrom: null as any,
                BillingTo: null as any,
                SiteOwnerID: null,
                Latitude: null,
                Longitude: null,
                Accuracy: null,
                Altitude: null,
                Heading: null,
                Radius: null,
                IsMocked: null as any,
                WorkOrderNumber: null,
                ClientSiteCode: null,
                WorkOrderDate: null,
                ValidTill: null,
                WorkOrderValue: null,
                ContractStartDate: null,
                ContractValue: null,
                AnnualValue: null,
                Narration: null,
                AgreementType: null,
                NoOfAgreement: null,
                ReportType: null,
                Tender: null,
                TenureOfContract: null,
                MinimumEscalationClause: null,
                BillingName: null,
                ManpowerCost: null,
                ManpowerOption: null,
                ManpowerValue: null,
                MachineryCost: null,
                MachineryOption: null,
                MachineryValue: null,
                ConsumableCost: null,
                ConsumableOption: null,
                ConsumableValue: null,
                ManagementFees: null,
                MgmtFeesValue: null,
                UniformOption: null,
                SiteType: null,
                OtherChargesOption: null,
                OtherCharges: null,
                SiteStartDate: null,
                SiteEndDate: null,
                RBIIndex: null,
                MinWages: null,
                PerIncGrowth: null,
                GuardBoardIndex: null,
                NewIndustrySegment: null,
                SubServiceType: null,
                NewSubLocation1: null,
                NewSubLocation2: null,
                OperationTeamEmailId: null,
                CompNatureofWork: null,
                AreaSqFt: null,
                MaterialChgType: null as any,
                MaterialChgVal: null,
                MachineryChgType: null as any,
                MachineryChgVal: null,
                ESS_SiteManpower: [],
                ESS_ShiftDetails: [],
                UserId: null,

                PPUMachineryCost: null,
                PPUBGCost: null,
                PPUBusinessProvisionPercent: null,
                PPUBusinessProvisionValue: null,
                CISMarginValue: null,
                Sitecount: null,
                ManpowerStrength: null,
                AttendanceDateValue: null,
                SalaryDateValue: null,
                SalaryPaymentDateValue: null,
                BillingDateValue: null,
                SiteTypeID: null,

                IsInternalPOCApplicable: null as any,
                InternalPOCName: null,
                InternalPOCMobileNo: null,
                InternalPOCMailId: null,
                IsClientPOCApplicable: null as any,

                // code
                IsClientAttendanceInformationMail: null as any,
                ClientPOCName: null,
                ClientPOCMobileNo: null,
                ClientPOCMailId: null,
                IsAltitudeApplicable: null as any,
                AltitudeRadius: null,

                SiteChannelId: null,
                SiteOracleCode: null,
                SiteAlternateCode: null,
                SiteAgreementCopyAttachment: null,
                SiteBankId: null,
                SiteAttendanceThrough: null,
                SiteLeaveSalarCycle: null,
                SiteLeaveSalary: null,
                SitePayoutBonusesCycle: null,
                SitePayoutBonus: null,
                SiteGratuity: null,
                SiteUniforms: null,
                SiteIsUniformsDeposit: null as any,
                SiteMinimumWageIndustry: null,
                SiteMinimumWageZone: null,
                SiteMinimumWageStructure: null,
                SiteBillTo: null,
                SiteShipTo: null,
                SiteAutoMail: null as any,
                SitePlaceOfSupplyApplicable: null as any,
                SiteDefaultNarration: null,
                SiteSubGroupMasterID: null
              }
              
              for (const [index, helement] of this.ExcelHeaders[this.ExcelHeadersIndex].Headers.entries()) {
                this.excelDataResult[rindex][helement] = element[index];
                const excelHIndex = this.excelHeader.findIndex((e: any) => this.common.ToLowerCase(e.replace(/\s+/g, '')) == this.common.ToLowerCase(helement.replace(/\s+/g, '')));
                if (excelHIndex >= 0 && this.recodecheck) {
                  if (index == 0) {
                    if (element[excelHIndex].toString().replace(/\s+/g, '') != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && element[excelHIndex] > 0) {
                      SiteIndertUpdate.SelectType = 'EU';
                      SiteIndertUpdate.SiteMasterId = element[excelHIndex];
                    } else {
                      SiteIndertUpdate.SelectType = 'EI';
                    }

                  } else if (index == 1) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      SiteIndertUpdate.SiteCode = element[excelHIndex];
                    } else {
                      element.Result = "Location Code blank not allow";
                      this.recodecheck = false;
                    }
                  } else if (index == 2) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      SiteIndertUpdate.SiteName = element[excelHIndex];
                    } else {
                      element.Result = "Location Name blank not allow";
                      this.recodecheck = false;
                    }
                  } else if (index == 3) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.BranchMaster.findIndex(e => e.BranchName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                        SiteIndertUpdate.BranchID = this.BranchMaster[this.BranchMaster.findIndex(e => e.BranchName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].BranchMasterID;
                        await this.loadSiteData(SiteIndertUpdate.BranchID);
                      } else {
                        element.Result = "Branch Name not found";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result = "Branch Name blank not allow";
                      this.recodecheck = false;
                    }
                  } else if (index == 4 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {

                  } else if (index == 5) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.CustomerGroup.findIndex((e: any) => e.ClientGroupName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                        SiteIndertUpdate.ClientGroupId = this.CustomerGroup[this.CustomerGroup.findIndex((e: any) => e.ClientGroupName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].ClientGroupMasterID;
                        //need to check max Client group
                        await this.BillCustLoad(SiteIndertUpdate.ClientGroupId);
                      } else {
                        element.Result = "Client Group Name not found";
                        this.recodecheck = false;
                      }
                    }
                  } else if (index == 6 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.BillingCustomer.findIndex((e: any) => e.ClientGroupName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                      SiteIndertUpdate.MaxClientId = this.BillingCustomer[this.BillingCustomer.findIndex((e: any) => e.ClientGroupName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].ClientGroupID;
                    } else {
                      element.Result = "Max Client Name not found";
                      this.recodecheck = false;
                    }
                  } else if (index == 7 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {

                  } else if (index == 8) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.IndustrySeg.findIndex((e: any) => e.IndustrySegmentName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                        SiteIndertUpdate.IndustrySegmentID = this.IndustrySeg[this.IndustrySeg.findIndex((e: any) => e.IndustrySegmentName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].IndustrySegmentID;
                      } else {
                        element.Result = "Industry Segment Name not found";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result = "Industry Segment Name  blank not allow";
                      this.recodecheck = false;
                    }
                  } else if (index == 9) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.Group.findIndex((e: any) => e.GroupName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                        SiteIndertUpdate.GroupID = this.Group[this.Group.findIndex((e: any) => e.GroupName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].GroupMasterID;
                      } else {
                        element.Result = "Rate Contract Group not found";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result = "Rate Contract Group blank not allow";
                      this.recodecheck = false;
                    }
                  } else if (index == 10 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.ZoneMaster.findIndex((e: any) => e.ZoneName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                      SiteIndertUpdate.ZoneId = this.ZoneMaster[this.ZoneMaster.findIndex((e: any) => e.ZoneName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].ZoneMasterID;
                    } else {
                      element.Result = "Zone not found";
                      this.recodecheck = false;
                    }
                  } else if (index == 11 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {

                  } else if (index == 12 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.SubGroups.findIndex((e: any) => e.SiteSubGroupName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                      SiteIndertUpdate.SiteSubGroupMasterID = this.SubGroups[this.SubGroups.findIndex((e: any) => e.SiteSubGroupName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].SiteSubGroupMasterID;
                    } else {
                      element.Result = "SiteSubGroupName not found";
                      this.recodecheck = false;
                    }
                  } else if (index == 13 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {

                  } else if (index == 14) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.Channels.findIndex((e: any) => e.ChannelName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                        SiteIndertUpdate.SiteChannelId = this.Channels[this.Channels.findIndex((e: any) => e.ChannelName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].ChannelMasterID;
                      } else {
                        element.Result = "ChannelName not found";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result = "ChannelName blank not allow";
                      this.recodecheck = false;
                    }
                  } else if (index == 15 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.ServiceType.findIndex((e: any) => e.ServiceTypeName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                      SiteIndertUpdate.ServiceTypeID = this.ServiceType[this.ServiceType.findIndex((e: any) => e.ServiceTypeName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].ServiceTypeID;
                    } else {
                      element.Result = "Service Type Name not found";
                      this.recodecheck = false;
                    }
                  } else if (index == 16 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.Banks.findIndex((e: any) => e.BankName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                      SiteIndertUpdate.SiteBankId = this.Banks[this.Banks.findIndex((e: any) => e.BankName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].OurCompanyBankMasterID;
                    } else {
                      element.Result = "Bank not found";
                      this.recodecheck = false;
                    }
                  } else if (index == 17) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      SiteIndertUpdate.Address1 = element[excelHIndex];
                    } else {
                      element.Result = "Address 1 blank not allow";
                      this.recodecheck = false;
                    }
                  } else if (index == 18 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.Address2 = element[excelHIndex];
                  } else if (index == 19 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.City = element[excelHIndex];
                  } else if (index == 20) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.State.findIndex((e: any) => e.StateName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                        SiteIndertUpdate.StateID = this.State[this.State.findIndex((e: any) => e.StateName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].StateMasterID;
                        await this.ComboLoad('District', SiteIndertUpdate.StateID);
                      } else {
                        element.Result = "State Name not found";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result = "State Name blank not allow";
                      this.recodecheck = false;
                    }
                  } else if (index == 21) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.District.findIndex((e: any) => e.DistrictName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                        SiteIndertUpdate.DistrictID = this.District[this.District.findIndex((e: any) => e.DistrictName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].DistrictMasterID;
                        await this.ComboLoad('Taluka', SiteIndertUpdate.StateID, SiteIndertUpdate.DistrictID);
                      } else {
                        element.Result = "District Name not found";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result = "District Name blank not allow";
                      this.recodecheck = false;
                    }
                  } else if (index == 22 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.Taluka.findIndex((e: any) => e.TalukaName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                        SiteIndertUpdate.TalukaID = this.Taluka[this.Taluka.findIndex((e: any) => e.TalukaName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].TalukaMasterID;
                      } else {
                        element.Result = "Taluka Name not found";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result = "Taluka Name blank not allow";
                      this.recodecheck = false;
                    }
                  } else if (index == 23 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.PinCode = element[excelHIndex];
                  } else if (index == 24 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.TelephoneNo = element[excelHIndex];
                  } else if (index == 25) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      SiteIndertUpdate.ContactPersonName = element[excelHIndex];
                    } else {
                      element.Result = "ContactPersonName blank not allow";
                      this.recodecheck = false;
                    }
                  } else if (index == 26 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.ContactPersonNo = element[excelHIndex];
                  } else if (index == 27) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      SiteIndertUpdate.ContactPersonEmail = element[excelHIndex];
                    } else {
                      element.Result = "ContactPersonEmail blank not allow";
                      this.recodecheck = false;
                    }
                  } else if (index == 28) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.BillTypes.findIndex((e: any) => e.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                        SiteIndertUpdate.BillType = this.BillTypes[this.BillTypes.findIndex((e: any) => e.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))];
                      } else {
                        element.Result = "BillType not found";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result = "BillType blank not allow";
                      this.recodecheck = false;
                    }
                  } else if (index == 28) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.BillTypes.findIndex((e: any) => e.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                        SiteIndertUpdate.BillType = this.BillTypes[this.BillTypes.findIndex((e: any) => e.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))];
                      } else {
                        element.Result = "BillType not found";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result = "BillType blank not allow";
                      this.recodecheck = false;
                    }
                  } else if (index == 29 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.Compliance.findIndex((e: any) => e.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                      SiteIndertUpdate.Compliance = this.Compliance[this.Compliance.findIndex((e: any) => e.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))];
                    } else {
                      element.Result = "Compliance not found";
                      this.recodecheck = false;
                    }
                  } else if (index == 30) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.PFApplicable = true;
                    } else {
                      SiteIndertUpdate.PFApplicable = false;
                    }
                  } else if (index == 31) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.ESICApplicable = true;
                    } else {
                      SiteIndertUpdate.ESICApplicable = false;
                    }
                  } else if (index == 32) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.PTApplicable = true;
                    } else {
                      SiteIndertUpdate.PTApplicable = false;
                    }
                  } else if (index == 33) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.LWFApplicable = true;
                    } else {
                      SiteIndertUpdate.LWFApplicable = false;
                    }
                  } else if (index == 34) {

                  } else if (index == 35) {

                  } else if (index == 36) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (isValidDate(element[excelHIndex])) {
                        SiteIndertUpdate.SiteStartDate = element[excelHIndex];
                      } else {
                        element.Result = "SiteStartDate allow formate DD MMM YYYY ex. 08 Apr 2026";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result = "SiteStartDate blank not allow";
                      this.recodecheck = false;
                    }
                  } else if (index == 37) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (isValidDate(element[excelHIndex])) {
                        SiteIndertUpdate.SiteEndDate = element[excelHIndex];
                      } else {
                        element.Result = "SiteEndDate allow formate DD MMM YYYY ex. 08 Apr 2026";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result = "SiteEndDate blank not allow";
                      this.recodecheck = false;
                    }
                  } else if (index == 38) {

                  } else if (index == 39) {

                  } else if (index == 40) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.SiteOwner.findIndex((e: any) => e.SiteOwnerName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                        SiteIndertUpdate.SiteOwnerID = this.SiteOwner[this.SiteOwner.findIndex((e: any) => e.SiteOwnerName.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].SiteOwnerMasterID;
                      } else {
                        element.Result = "SiteOwner not found";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result = "SiteOwner blank not allow";
                      this.recodecheck = false;
                    }
                  } else if (index == 41 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (!isNaN(element[excelHIndex])) {
                      SiteIndertUpdate.Latitude = element[excelHIndex];
                    }
                  } else if (index == 42 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (!isNaN(element[excelHIndex])) {
                      SiteIndertUpdate.Longitude = element[excelHIndex];
                    }
                  } else if (index == 43 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (!isNaN(element[excelHIndex])) {
                      SiteIndertUpdate.Longitude = element[excelHIndex];
                    }
                  } else if (index == 44 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (!isNaN(element[excelHIndex])) {
                      SiteIndertUpdate.Accuracy = element[excelHIndex];
                    }
                  } else if (index == 45 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (!isNaN(element[excelHIndex])) {
                      SiteIndertUpdate.Altitude = element[excelHIndex];
                    }
                  } else if (index == 46 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (!isNaN(element[excelHIndex])) {
                      SiteIndertUpdate.Heading = element[excelHIndex];
                    }
                  } else if (index == 47 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.IsMocked = true;
                    } else {
                      SiteIndertUpdate.IsMocked = false;
                    }
                  } else if (index == 48 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.IsAltitudeApplicable = true;
                    } else {
                      SiteIndertUpdate.IsAltitudeApplicable = false;
                    }
                  } else if (index == 49 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (!isNaN(element[excelHIndex])) {
                      SiteIndertUpdate.AltitudeRadius = element[excelHIndex];
                    }
                  } else if (index == 50) {

                  } else if (index == 51 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (!isNaN(element[excelHIndex])) {
                      SiteIndertUpdate.AreaSqFt = element[excelHIndex];
                    }
                  } else if (index == 52 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.MaterialChgVal = element[excelHIndex];
                  } else if (index == 53 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.MaterialChargesType.findIndex((e: any) => e.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                      SiteIndertUpdate.MaterialChgType = this.MaterialChargesType[this.MaterialChargesType.findIndex((e: any) => e.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))];
                    } else {
                      element.Result = "MaterialChargeType not found";
                      this.recodecheck = false;
                    }
                  } else if (index == 54 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    if (this.MachineryChargesType.findIndex((e: any) => e.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                      SiteIndertUpdate.MachineryChgType = this.MachineryChargesType[this.MachineryChargesType.findIndex((e: any) => e.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))];
                    } else {
                      element.Result = "Machinery Charge Type not found";
                      this.recodecheck = false;
                    }
                  } else if (index == 55 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.MachineryChgVal = element[excelHIndex];
                  } else if (index == 56) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'datewise') {
                        SiteIndertUpdate.SalaryCalcType = 'D';
                      } else if (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'monthwise') {
                        SiteIndertUpdate.SalaryCalcType = 'M';
                        SiteIndertUpdate.SalaryFrom = 1;
                        SiteIndertUpdate.SalaryTo = 0;
                      } else {
                        element.Result = "SalaryCalcType only allow Datewise or MonthWise";
                        this.recodecheck = false;
                      }
                    } else {
                      SiteIndertUpdate.SalaryCalcType = 'M';
                    }
                  } else if (index == 57 && SiteIndertUpdate.SalaryCalcType == 'D') {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (!isNaN(element[excelHIndex])) {
                        if (parseInt(element[excelHIndex].toString()) >= 2 && parseInt(element[excelHIndex].toString()) <= 28) {
                          SiteIndertUpdate.SalaryFrom = parseInt(element[excelHIndex].toString());
                          SiteIndertUpdate.SalaryTo = parseInt(element[excelHIndex].toString()) - 1;
                        } else {
                          element.Result = "Salary From only allow 2 to 28";
                          this.recodecheck = false;
                        }
                      } else {
                        element.Result = "Salary From only allow 2 to 28";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result = "Salary From only allow 2 to 28";
                      this.recodecheck = false;
                    }
                  } else if (index == 58) { }
                  else if (index == 59 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                  } else if (index == 60) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'datewise') {
                        SiteIndertUpdate.BillingCalcType = 'D';
                      } else if (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'monthwise') {
                        SiteIndertUpdate.BillingCalcType = 'M';
                        SiteIndertUpdate.BillingFrom = 1;
                        SiteIndertUpdate.BillingTo = 0;
                      } else {
                        element.Result = "BillingCalcType only allow Datewise or MonthWise";
                        this.recodecheck = false;
                      }
                    } else {
                      SiteIndertUpdate.BillingCalcType = 'M';
                    }
                  } else if (index == 61 && SiteIndertUpdate.SalaryCalcType == 'D') {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                      if (!isNaN(element[excelHIndex])) {
                        if (parseInt(element[excelHIndex].toString()) >= 2 && parseInt(element[excelHIndex].toString()) <= 28) {
                          SiteIndertUpdate.BillingFrom = parseInt(element[excelHIndex].toString());
                          SiteIndertUpdate.BillingTo = parseInt(element[excelHIndex].toString()) - 1;
                        } else {
                          element.Result = "Billing From only allow 2 to 28";
                          this.recodecheck = false;
                        }
                      } else {
                        element.Result = "Billing From only allow 2 to 28";
                        this.recodecheck = false;
                      }
                    } else {
                      element.Result = "Billing From only allow 2 to 28";
                      this.recodecheck = false;
                    }
                  } else if (index == 62) {

                  } else if (index == 63) {

                  } else if (index == 64) {

                  } else if (index == 65) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.IsInternalPOCApplicable = true;
                    } else {
                      SiteIndertUpdate.IsInternalPOCApplicable = false;
                    }
                  } else if (index == 66 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.InternalPOCName = element[excelHIndex];
                  } else if (index == 67 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.InternalPOCMobileNo = element[excelHIndex];
                  } else if (index == 68 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.InternalPOCMailId = element[excelHIndex];
                  } else if (index == 69) {
                    if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                      SiteIndertUpdate.IsClientPOCApplicable = true;
                    } else {
                      SiteIndertUpdate.IsClientPOCApplicable = false;
                    }
                  } else if (index == 70 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.ClientPOCName = element[excelHIndex];
                  } else if (index == 71 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.ClientPOCMobileNo = element[excelHIndex];
                  } else if (index == 72 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.ClientPOCMailId = element[excelHIndex];
                  }
                } else if (index == 73) {
                  if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                    SiteIndertUpdate.SiteOracleCode = element[excelHIndex];
                  } else {
                    element.Result = "SiteOracleCode blank not allow";
                    this.recodecheck = false;
                  }
                } else if (index == 74 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                  SiteIndertUpdate.SiteAlternateCode = element[excelHIndex];
                } else if (index == 75) {

                } else if (index == 76 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                  if (this.AttendanceThroughLoad.findIndex((e: any) => e.AttendanceThrough.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                    SiteIndertUpdate.SiteAttendanceThrough = this.AttendanceThroughLoad[this.AttendanceThroughLoad.findIndex((e: any) => e.AttendanceThrough.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].AttendanceThrough;
                  } else {
                    element.Result = "SiteAttendanceThrough not found";
                    this.recodecheck = false;
                  }
                } else if (index == 77 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                  if (this.LeaveSalaryCycleLoad.findIndex((e: any) => e.LeaveSalarCycle.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                    SiteIndertUpdate.SiteLeaveSalarCycle = this.LeaveSalaryCycleLoad[this.LeaveSalaryCycleLoad.findIndex((e: any) => e.LeaveSalarCycle.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].LeaveSalarCycle;
                  } else {
                    element.Result = "SiteLeaveSalarCycle not found";
                    this.recodecheck = false;
                  }
                } else if (index == 78 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                  if (this.LeaveSalaryPayoutLoad.findIndex((e: any) => e.LeaveSalary.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                    SiteIndertUpdate.SiteLeaveSalary = this.LeaveSalaryPayoutLoad[this.LeaveSalaryPayoutLoad.findIndex((e: any) => e.LeaveSalary.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].LeaveSalary;
                  } else {
                    element.Result = "SiteLeaveSalary not found";
                    this.recodecheck = false;
                  }
                } else if (index == 79 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                  if (this.PayoutBonusesCycleLoad.findIndex((e: any) => e.PayoutBonusesCycle.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                    SiteIndertUpdate.SitePayoutBonusesCycle = this.PayoutBonusesCycleLoad[this.PayoutBonusesCycleLoad.findIndex((e: any) => e.PayoutBonusesCycle.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].PayoutBonusesCycle;
                  } else {
                    element.Result = "SitePayoutBonusesCycle not found";
                    this.recodecheck = false;
                  }
                } else if (index == 80 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                  if (this.PayoutBonusLoad.findIndex((e: any) => e.PayoutBonus.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                    SiteIndertUpdate.SitePayoutBonus = this.PayoutBonusLoad[this.PayoutBonusLoad.findIndex((e: any) => e.PayoutBonus.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].PayoutBonus;
                  } else {
                    element.Result = "SitePayoutBonus not found";
                    this.recodecheck = false;
                  }
                } else if (index == 81 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                  if (this.GratuityLoad.findIndex((e: any) => e.Gratuity.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                    SiteIndertUpdate.SiteGratuity = this.GratuityLoad[this.GratuityLoad.findIndex((e: any) => e.Gratuity.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].Gratuity;
                  } else {
                    element.Result = "SiteGratuity not found";
                    this.recodecheck = false;
                  }
                } else if (index == 82 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                  if (this.UniformLoad.findIndex((e: any) => e.Uniforms.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                    SiteIndertUpdate.SiteUniforms = this.UniformLoad[this.UniformLoad.findIndex((e: any) => e.Uniforms.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].Uniforms;
                  } else {
                    element.Result = "SiteUniforms not found";
                    this.recodecheck = false;
                  }
                } else if (index == 83) {
                  if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                    SiteIndertUpdate.SiteIsUniformsDeposit = true;
                  } else {
                    SiteIndertUpdate.SiteIsUniformsDeposit = false;
                  }
                } else if (index == 84 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                  if (this.MinimumWageIndustryLoad.findIndex((e: any) => e.MinimumWageIndustry.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                    SiteIndertUpdate.SiteMinimumWageIndustry = this.MinimumWageIndustryLoad[this.MinimumWageIndustryLoad.findIndex((e: any) => e.MinimumWageIndustry.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].MinimumWageIndustry;
                  } else {
                    element.Result = "SiteMinimumWageIndustry not found";
                    this.recodecheck = false;
                  }
                } else if (index == 85 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                  if (this.MinimumWageZoneLoad.findIndex((e: any) => e.MinimumWageZone.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                    SiteIndertUpdate.SiteMinimumWageZone = this.MinimumWageZoneLoad[this.MinimumWageZoneLoad.findIndex((e: any) => e.MinimumWageZone.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].MinimumWageZone;
                  } else {
                    element.Result = "SiteMinimumWageZone not found";
                    this.recodecheck = false;
                  }
                } else if (index == 86 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                  if (this.WageStrutureLoad.findIndex((e: any) => e.MinimumWageStructure.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, '')) >= 0) {
                    SiteIndertUpdate.SiteMinimumWageStructure = this.WageStrutureLoad[this.WageStrutureLoad.findIndex((e: any) => e.MinimumWageStructure.replace(/\s+/g, '') == element[excelHIndex].toString().replace(/\s+/g, ''))].MinimumWageStructure;
                  } else {
                    element.Result = "SiteMinimumWageStructure not found";
                    this.recodecheck = false;
                  }
                } else if (index == 87 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                  if (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'site' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'client') {
                    SiteIndertUpdate.SiteBillTo = element[excelHIndex];
                  } else {
                    element.Result = "SiteBillTo only allow client or site";
                    this.recodecheck = false;
                  }
                } else if (index == 88 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                  if (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'site' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'client') {
                    SiteIndertUpdate.SiteShipTo = element[excelHIndex];
                  } else {
                    element.Result = "SiteShipTo only allow client or site";
                    this.recodecheck = false;
                  }
                } else if (index == 89) {
                  if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                    SiteIndertUpdate.SiteAutoMail = true;
                  } else {
                    SiteIndertUpdate.SiteAutoMail = false;
                  }
                } else if (index == 90) {
                  if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                    SiteIndertUpdate.SitePlaceOfSupplyApplicable = true;
                  } else {
                    SiteIndertUpdate.SitePlaceOfSupplyApplicable = false;
                  }
                } else if (index == 91 && element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '') {
                  SiteIndertUpdate.Narration = element[excelHIndex];
                } else if (index == 92) {
                  if (element[excelHIndex] != null && element[excelHIndex].toString().replace(/\s+/g, '') != '' && (this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'y' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')) == 'yes' || this.common.ToLowerCase(element[excelHIndex].toString().replace(/\s+/g, '')).toString() == 'true')) {
                    SiteIndertUpdate.IsClientAttendanceInformationMail = true;
                  } else {
                    SiteIndertUpdate.IsClientAttendanceInformationMail = false;
                  }
                }
              };

              if(this.recodecheck){
                await this.SaveandUpdateSiteMaster(SiteIndertUpdate,element);
              }
              this.excelDataResult[rindex].Result = element.Result;
            }
          }
          //console.log(this.excelDataResult);
          this.download.exportToExcel(this.excelDataResult, "Result");
          this.reset();
        }
      });
    }
  }

  async SaveFromExcelShiftGroup(element: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.shift.ESS_ShiftGroupMaster_Insert({
        SelectType: (element[this.excelHeader.findIndex((e: any) => e.replace(/\s+/g, '') == this.ExcelHeaders[0].Headers[0].replace(/\s+/g, ''))] > 0) ? 'Update' : 'Insert',
        ESS_ShiftGroupMasterId: element[this.excelHeader.findIndex((e: any) => e.replace(/\s+/g, '') == this.ExcelHeaders[0].Headers[0].replace(/\s+/g, ''))],
        ShiftGroupName: element[this.excelHeader.findIndex((e: any) => e.replace(/\s+/g, '') == this.ExcelHeaders[0].Headers[1].replace(/\s+/g, ''))],
      }).subscribe({
        next: (response) => {
          element.Result = response.Error_Message;
          resolve(true);
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    });
  }

  async SaveandUpdateSiteMaster(Saveelement: any,element:any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.isDisabled = true
      this.locationservice.SiteInsert(Saveelement).subscribe({
        next: async (response) => {
          element.Result = response.Error_Message;
          this.isDisabled = false;
          resolve(true);
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error: any) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    });
  }


  async loadSiteData(BranchID: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.isDisabled = true
      if (BranchID == null) {
        this.IndustrySeg = [];
        this.ServiceType = [];
        this.RegionMaster = [];
        this.BranchMaster = [];
        this.CustomerGroup = [];
        this.FinancialBranch = [];
        this.ReportTypeMaster = [];
        this.Group = [];
        this.State = [];
        this.DesignationLoad = [];
        this.DutyLoad = [];
        this.Channels = [];
        this.Banks = [];
        this.AttendanceThroughLoad = [];
        this.LeaveSalaryCycleLoad = [];
        this.LeaveSalaryPayoutLoad = [];
        this.PayoutBonusesCycleLoad = [];
        this.PayoutBonusLoad = [];
        this.GratuityLoad = [];
        this.UniformLoad = [];
        this.MinimumWageIndustryLoad = [];
        this.MinimumWageZoneLoad = [];
        this.WageStrutureLoad = [];
        this.Groups = [];
        this.SubGroups = [];
        this.FilteredSubGroups = [];
      } else if (BranchID > 0) {
        this.SiteOwner = [];
        this.ZoneMaster = [];
      }
      this.locationservice.SiteComboLoad({ ESS_SiteMasterId: '', SelecteType: 1, BranchID: BranchID, UserId: null }).subscribe({
        next: (data) => {
          if (BranchID == null) {
            this.IndustrySeg = data.IndustrySegmentMaster;
            this.ServiceType = data.ServiceTypeMaster;
            this.RegionMaster = data.RegionMaster;
            if (!this.common.CompanyParameterValue.CCCode) {
              this.BranchMaster = data.BranchMaster;
            }
            this.CustomerGroup = data.ClientGroupMaster;
            this.FinancialBranch = data.financialBranch;
            this.ReportTypeMaster = data.ReportTypeMaster;
            this.Group = data.GroupMaster;
            this.State = data.StateMaster;
            this.DesignationLoad = data.DesignationMaster;
            this.DutyLoad = data.DutyMaster;
            this.Channels = data.ChannelMaster;
            this.Banks = data.SiteBankMaster;
            this.AttendanceThroughLoad = data.AttendanceThrough;
            this.LeaveSalaryCycleLoad = data.LeaveSalarCycle;
            this.LeaveSalaryPayoutLoad = data.LeaveSalary;
            this.PayoutBonusesCycleLoad = data.PayoutBonusesCycle;
            this.PayoutBonusLoad = data.PayoutBonus;
            this.GratuityLoad = data.Gratuity;
            this.UniformLoad = data.Uniforms;
            this.MinimumWageIndustryLoad = data.MinimumWageIndustry;
            this.MinimumWageZoneLoad = data.MinimumWageZone;
            this.WageStrutureLoad = data.MinimumWageStructure;
            this.Groups = data.SiteGroupMaster;
            this.SubGroups = data.SiteSubGroupMaster;
            this.FilteredSubGroups = data.SiteSubGroupMaster;
          } else if (BranchID > 0) {
            this.SiteOwner = data.siteowner;
            this.ZoneMaster = data.ZoneMaster;
          }

          this.isDisabled = false
          resolve(true);
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false
          resolve(error);
          console.error('Error:', error);
        },
      });
    });
  }

  async BillCustLoad(CustGrpId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.isDisabled = true
      this.BillingCustomer = [];
      this.locationservice.BillCustLoad({ SelectType: 1, ClientGroupMasterId: CustGrpId }).subscribe({
        next: (data) => {
          if (data.Table.length > 0) {
            this.BillingCustomer = data.Table;
          }
          this.isDisabled = false
          resolve(true);
        },
        complete: () => {
        },
        error: (error) => {
          this.isDisabled = false
          resolve(error);
          console.error('Error:', error);
        },
      });
    });
  }

  async ComboLoad(Combotype: String, Stateid = 0, DistrictId = 0): Promise<any> {
    if (Combotype == 'District') {
      this.District = [];
    } else if (Combotype == 'Taluka') {
      this.Taluka = [];
    } else if (Combotype == 'SiteTypeMaster') {
      this.SiteType = [];
    }
    return new Promise((resolve, reject) => {
      this.isDisabled = true
      this.comboload.ComboLoad({
        'Combotype': Combotype,
        'StateId': (Combotype == 'District') ? Stateid : 0,
        'DistrictId': (Combotype == 'Taluka') ? DistrictId : 0
        // 'EmpType': 'front'
      }).subscribe({
        next: (response) => {
          if (Combotype == 'District') {
            this.District = response.ComboLoad;
          } else if (Combotype == 'Taluka') {
            this.Taluka = response.ComboLoad;
          } else if (Combotype == 'SiteTypeMaster') {
            this.SiteType = response.ComboLoad;
          }
          this.isDisabled = false;
          resolve(true);
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
          resolve(error);
        },
      });
    });
  }
}

export function isValidDate(input: string): boolean {
  if (!input || typeof input !== 'string') return false;

  const monthMap: { [key: string]: boolean } = {
    'jan': true, 'january': true,
    'feb': true, 'february': true,
    'mar': true, 'march': true,
    'apr': true, 'april': true,
    'may': true,
    'jun': true, 'june': true,
    'jul': true, 'july': true,
    'aug': true, 'august': true,
    'sep': true, 'september': true,
    'oct': true, 'october': true,
    'nov': true, 'november': true,
    'dec': true, 'december': true
  };

  const parts = input.trim().split(' ');
  if (parts.length !== 3) return false;

  const day = parseInt(parts[0], 10);
  const month = parts[1].toLowerCase();
  const year = parseInt(parts[2], 10);

  if (isNaN(day) || isNaN(year)) return false;
  if (day < 1 || day > 31) return false;
  if (year < 1900 || year > 2100) return false;
  if (!monthMap[month]) return false;

  return true;
}
